<template>
    <div>
        <textarea :id="id" class="form-control" v-model="valueModel" />
    </div>
</template>

<script>
export default {
    name: "BrickCommentEditor",
    computed: {
        valueModel: {
            get(){
                return this.value;
            },
            set(value){
                this.$emit('input', value);
            }
        }
    },
    props: {
        value: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: false
        }
    }
}
</script>
